// Deprecated.

import { withMetadata } from '../min/metadata'

import _isValidNumber from '../es6/validate'

export function isValidNumber() {
	return withMetadata(_isValidNumber, arguments)
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/index.es6.exports/isValidNumber.js
// module id = 644
// module chunks = 0